import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { FinanceService } from '@core/services/finance.service';

export const matchRequestResolver: ResolveFn<void> = async () => {
  await inject(FinanceService).setMatchRequests();
}
